import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import { t } from "i18next";
import * as Yup from "yup";

import { EmailSchema, PhoneNumberSchema } from "../../helpers/yup-schema";
import EmployeeService from "../../services/employee";

import CommonField from "../../components/CommonField";
import PhoneNumber from "../../components/PhoneNumber";
import EmailField from "../../components/EmailField";

const InitialValues = {
  firstName: "",
  lastName: "",
  mail: "",
  phoneNumber: "",
};

const ValidationSchema = EmailSchema("mail")
  .concat(PhoneNumberSchema())
  .shape({
    firstName: Yup.string().required(t("REQUIRED")).trim(),
    lastName: Yup.string().required(t("REQUIRED")).trim(),
  });

function InformationEmployee({ formData, getDataFn }) {
  // eslint-disable-next-line no-unused-vars
  const [setPageTitle, setCrumbItem] = useOutletContext();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setCrumbItem([
      { title: t("EMPLOYEE.TITLE"), link: "list" },
      { title: t("UPDATE_TITLE"), link: "#" },
    ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(false);

    setIsLoading(true);
    await EmployeeService.updateEmployee({ ...values })
      .then((response) => {
        const { status, message } = response.data;

        if (status === 400) {
          toast.error(message);
          return;
        }

        toast.success(message);
        getDataFn();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={{ ...InitialValues, ...formData }}
        enableReinitialize={true}
        validationSchema={ValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Row>
              {/* First Name */}
              <Col xs={6} sm={4}>
                <div className="mb-4">
                  <CommonField
                    fieldName="firstName"
                    label="FIRST_NAME_LABEL"
                    placeholder="FIRST_NAME_PLACEHOLDER"
                    required={true}
                  />
                </div>
              </Col>

              {/* Last Name */}
              <Col xs={6} sm={4}>
                <div className="mb-4">
                  <CommonField
                    fieldName="lastName"
                    label="LAST_NAME_LABEL"
                    placeholder="LAST_NAME_PLACEHOLDER"
                    required={true}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              {/* Email */}
              <Col sm={4}>
                <div className="mb-4">
                  <EmailField
                    isRequired={true}
                    showVerification={false}
                    isDisabled={true}
                  />
                </div>
              </Col>

              {/* Mobile */}
              <Col sm={4}>
                <div className="mb-4">
                  <PhoneNumber
                    fieldName="phoneNumber"
                    fieldLabel={t("MOBILE_NO_LABEL")}
                    required={true}
                    isDisabled={true}
                  />
                </div>
              </Col>
            </Row>

            <div className="button-items">
              {/* Submit Button */}
              <Button
                color="primary"
                className="w-md waves-effect waves-light"
                type="submit"
                disabled={isSubmitting || isLoading}
              >
                {isSubmitting || isLoading ? t("PLEASE_WAIT") : t("SUBMIT")}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}

export default InformationEmployee;
